import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import Description from '../../components/Description/Description'

import { mapGroups } from './utils'

import styles from './ChooseGroup.module.scss'

const ChooseGroup = ({ list, onSelect = () => {} }) => {
    const { t } = useTranslation()
    const [groups, setGroups] = useState([])

    useEffect(() => {
        if (!list.length) return
        setGroups(mapGroups(list))
    }, [list])

    if (!groups.length) return null

    return (
        <div className={styles.group}>
            <Description
                title={t('Choose your sector')}
                subTitle={t('Choose the option that best represents you.')}
                isCentered
                width={460}
            />
            <ul className={styles.list}>
                {groups.map(group => (
                    <li key={group.id} className={styles.item} onClick={() => onSelect(group)}>
                        <div className={styles.itemImage} style={{ backgroundImage: `url(${group.image})` }}></div>
                        <div className={styles.itemText}>
                            <p className={styles.itemTitle}>{group.title}</p>
                            <p className={styles.itemDescription}>{group.description}</p>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    )
}

export default ChooseGroup
